import { Spinner, Center, Box } from "@chakra-ui/react";

const Loader = () => (
  <Center h="100vh" bg="gray.50">
    <Box textAlign="center">
      <Spinner size="xl" color="blue.500" thickness="4px" speed="0.65s" />
      <Box mt={4} fontSize="lg" fontWeight="semibold" color="gray.600">
        Loading...
      </Box>
    </Box>
  </Center>
);

export default Loader;
